
      // console.log("=== Google Analytics Debug ===");
      // console.log("MODE:", import.meta.env.MODE);
      // console.log("PROD:", import.meta.env.PROD);
      // console.log("DEV:", import.meta.env.DEV);
      // console.log("ENABLE_ANALYTICS:", import.meta.env.VITE_ENABLE_ANALYTICS);
      // console.log("==========================");

      if (import.meta.env.VITE_ENABLE_ANALYTICS === "true") {
        // console.log("Google Analytics yükleniyor...");
        const script1 = document.createElement("script");
        script1.async = true;
        script1.src =
          "https://www.googletagmanager.com/gtag/js?id=G-YFVMHK3GKM";
        document.head.appendChild(script1);

        const script2 = document.createElement("script");
        script2.textContent = `
          window.dataLayer = window.dataLayer || [];
          function gtag(){dataLayer.push(arguments);}
          gtag('js', new Date());
          gtag('config', 'G-YFVMHK3GKM');
        `;
        document.head.appendChild(script2);
        // console.log("Google Analytics yüklendi!");
      } else {
        // console.log("Google Analytics yüklenmedi - Analytics devre dışı");
      }
    